import { Id } from "@planzone/dto";
import { gantt } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, projectId: Id) {
  return getState().find((res) => res.project.uuid === projectId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isProjectGanttRetrievalRequestFailure({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isFailure, false);
    },
    isProjectGanttRetrievalRequestPending({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isPending, false);
    },
    isProjectGanttRetrievalRequestSuccess({ uuid }) {
      return queryState(getState, uuid)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getProjectGantt({ uuid }) {
      return queryState(getState, uuid)((res) => res.gantt, gantt);
    },
  };
}

export { createSelector };
